




























export default
# 	components:
	inject: estimatedTimeToComplete: default: 'default:'

	props:
		id: String
		estimate: String
		type: String

		disabled:
			type: Boolean
			default: false

		errorMessage: String

	computed:
		hasDisclaimer: -> !!@$slots.disclaimer?[0]?.text?.length

	methods:
		onClick: -> @$emit 'click'

